<script>
const LangListAPI = "https://ams4you.net/amsapi/public/websearch/GetLangLanguageList";
const LangChangeAPI = "https://ams4you.net/amsapi/public/websearch/GetLangLanguageChange";

import axios from "axios";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
export default {
    components: {
        Datepicker,
    },
    data() {
        return {
            query: "",
            SelLang: {},
            SelCountry: {},
            SelWeek: {},
            SelDate: "",
            LanguageList: [],
            CountryList: [],
        };
    },
    computed: {
        WeekList() {
            let list = [];
            for (let i = 1; i <= 52; i++) {
                list.push({
                    Id: i,
                    Name: i == 1 ? i + " week" : i + " weeks",
                });
            }
            return list;
        },
        Setting() {
            return this.$parent.Setting;
        },
        Translation() {
            return this.$parent.Translation;
        },
        SetDataStep() {
            if (this.SelWeek?.Id) {
                return 4;
            }
            if (this.SelCountry?.Id) {
                return 3;
            }
            if (this.SelLang?.LanguageId) {
                return 2;
            }
            return 1;
        },
        LanguageSelected() {
            if (!this.SelWeek?.Id) return false;
            if (!this.SelCountry?.Id) return false;
            if (!this.SelLang?.LanguageId) return false;
            if (!this.SelDate) return false;

            return true;
        },
    },
    watch: {
        SelLang(val) {
            this.SelCountry = {
                Id: 0,
                Name: "-",
            };
            this.LanguageList.CountryList = [];
            if (val?.LanguageId) {
                let LatestQuery = this.query + "&LanguageId=" + val.LanguageId;
                this.GetCountries(LatestQuery);
            }
        },
    },
    methods: {
        MakeSearch() {
            let Path = "https://my.alternatifecs.com/search/language";

            let query = "?CountryId=" + this.SelCountry.Id + "&LevelId=" + this.SelLang.LanguageId + "&Weeks=" + this.SelWeek.Id + "&StartDate=" + moment(this.SelDate).format("YYYY-MM-DD");
            window.open(Path + query, this.Setting.OpenInNewWindow ? "_blank" : "_self");
        },
        async GetLanguageList() {
            let ag = this.$parent.ag;
            let wid = this.$parent.wid;
            this.query = "?ag=" + ag + "&wfid=" + wid;
            const request = await axios.get(LangListAPI + this.query);
            const response = request.data;
            this.LanguageList = response.detail;
        },
        async GetCountries(Query) {
            const request = await axios.get(LangChangeAPI + Query);
            const response = request.data;
            this.CountryList = response.detail;
        },
        ClearAll() {
            this.SelLang = {};
            this.SelCountry = {};
            this.SelWeek = {
                Id: "",
                Name: "",
            };
            this.SelDate = "";
        },
    },
    mounted() {
        this.GetLanguageList();
        this.SelDate = new Date(moment().add(1, "month").toJSON());
    },
};
</script>
<template>
    <div
        class="card-type"
        :class="{
            active: LanguageSelected,
        }"
    >
        <div class="card-type-head">
            <div class="type-data">
                <h5 class="title">Dil Eğitimi</h5>
                <p class="desc">
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit. Numquam perferendis quibusdam mollitia voluptatibus adipisci voluptas dolore fugiat commodi dignissimos vel!
                </p>
            </div>
        </div>
        <div class="card-type-content">
            <div class="input-group input-group-blur" :data-step="SetDataStep">
                <div class="input-row">
                    <div class="input-icon"></div>
                    <div class="input-content">
                        <label class="input-label">Dil Seçiniz</label>
                        <v-select
                            class="form-control"
                            :options="LanguageList"
                            :getOptionLabel="(option) => option.LanguageName || '-'"
                            label="LanguageName"
                            :clearable="false"
                            v-model="SelLang"
                            @option:selected="
                                SelWeek = {};
                                SelDate = '';
                                SelCountry = {};
                            "
                        />
                    </div>
                </div>
                <div class="input-row">
                    <div class="input-icon"></div>
                    <div class="input-content">
                        <label class="input-label">Ülke Seçiniz</label>
                        <v-select
                            class="form-control"
                            :options="CountryList"
                            label="Name"
                            :getOptionLabel="(option) => option.Name || '-'"
                            placeholder="Ülke seçiniz"
                            :clearable="false"
                            v-model="SelCountry"
                            @option:selected="
                                SelWeek = {};
                                SelDate = '';
                            "
                            :disabled="!SelLang?.LanguageId"
                        />
                    </div>
                </div>
                <div class="input-row">
                    <div class="input-icon"></div>
                    <div class="input-content">
                        <label class="input-label">Hafta Seçiniz</label>
                        <v-select
                            class="form-control"
                            :options="WeekList"
                            label="Name"
                            :getOptionLabel="(option) => option.Name || '-'"
                            :clearable="false"
                            v-model="SelWeek"
                            :disabled="!SelCountry?.Id"
                        />
                    </div>
                </div>
                <div class="input-row">
                    <div class="input-icon"></div>
                    <div class="input-content">
                        <label class="input-label">Başlangıç Tarihi</label>
                        <datepicker
                            :disabled-dates="{
                                to: new Date(),
                            }"
                            v-model="SelDate"
                            :disabled="!SelWeek?.Id || !SelCountry?.Id"
                            class="form-control"
                            :editable="false"
                            placeholder="-"
                            :format="'dd-MM-yyyy'"
                        ></datepicker>
                    </div>
                </div>
                <div class="form-progress"></div>
            </div>
            <div class="btn-grid">
                <button type="button" class="btn btn-link" @click="ClearAll" v-if="SetDataStep > 1">
                    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M22.452 1.923a.75.75 0 0 1 0 1.06L16.14 9.296a6.814 6.814 0 0 0-1.067-1.053l6.32-6.32a.75.75 0 0 1 1.06 0ZM15.028 9.347a5.75 5.75 0 0 0-8.132 0l-.244.244 8.132 8.132.244-.244a5.75 5.75 0 0 0 0-8.132ZM1.884 12.966l3.613-2.409 8.32 8.321-2.408 3.613a.75.75 0 0 1-1.154.115L1.769 14.12a.75.75 0 0 1 .115-1.154Z"
                            fill="#fb4747"
                        />
                    </svg>
                    Seçimi Temizle
                </button>
                <button type="button" class="btn btn-data" :disabled="!LanguageSelected" @click="MakeSearch">
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0,0,256,256" style="fill: #000000">
                        <g
                            fill="#ffffff"
                            fill-rule="nonzero"
                            stroke="none"
                            stroke-width="1"
                            stroke-linecap="butt"
                            stroke-linejoin="miter"
                            stroke-miterlimit="10"
                            stroke-dasharray=""
                            stroke-dashoffset="0"
                            font-family="none"
                            font-weight="none"
                            font-size="none"
                            text-anchor="none"
                            style="mix-blend-mode: normal"
                        >
                            <g transform="scale(8.53333,8.53333)">
                                <path
                                    d="M13,3c-5.511,0 -10,4.489 -10,10c0,5.511 4.489,10 10,10c2.39651,0 4.59738,-0.85101 6.32227,-2.26367l5.9707,5.9707c0.25082,0.26124 0.62327,0.36648 0.97371,0.27512c0.35044,-0.09136 0.62411,-0.36503 0.71547,-0.71547c0.09136,-0.35044 -0.01388,-0.72289 -0.27512,-0.97371l-5.9707,-5.9707c1.41266,-1.72488 2.26367,-3.92576 2.26367,-6.32227c0,-5.511 -4.489,-10 -10,-10zM13,5c4.43012,0 8,3.56988 8,8c0,4.43012 -3.56988,8 -8,8c-4.43012,0 -8,-3.56988 -8,-8c0,-4.43012 3.56988,-8 8,-8z"
                                ></path>
                            </g>
                        </g>
                    </svg>
                    Sonuçları gör
                </button>
            </div>
        </div>
    </div>
</template>
